import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'Heart',
      title: 'Salva le tue Vetrine',
      description: 'Crea una lista personalizzata delle attività preferite per trovarle velocemente'
    },
    {
      icon: 'Tag',
      title: 'Promozioni Esclusive',
      description: 'Accedi a offerte speciali riservate agli utenti registrati'
    },
    {
      icon: 'Wallet',
      title: 'Cashback Attivo',
      description: 'Accumula cashback sugli acquisti e risparmia sui tuoi negozi preferiti'
    },
    {
      icon: 'Bell',
      title: 'Notifiche Personalizzate',
      description: 'Ricevi avvisi su nuove promozioni nelle zone e categorie che ti interessano'
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-warm p-6 md:p-8">
      <div className="space-y-4 md:space-y-6">
        <div className="text-center space-y-2">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-full">
            <Icon name="Sparkles" size={32} color="var(--color-primary)" />
          </div>
          <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground">
            Vantaggi dell'Account
          </h3>
          <p className="text-sm md:text-base text-muted-foreground">
            Scopri tutti i benefici della registrazione
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:gap-6">
          {benefits?.map((benefit, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-4 rounded-lg bg-background hover:bg-muted transition-smooth"
            >
              <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={benefit?.icon} size={24} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0 space-y-1">
                <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
                  {benefit?.title}
                </h4>
                <p className="text-sm md:text-base text-muted-foreground">
                  {benefit?.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="pt-4 border-t border-border">
          <div className="flex items-center gap-3 p-4 bg-accent/10 rounded-lg">
            <Icon name="Shield" size={24} color="var(--color-accent)" />
            <p className="text-sm md:text-base text-foreground">
              <span className="font-semibold">100% Sicuro:</span> I tuoi dati sono protetti secondo la normativa GDPR europea
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;